import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export type DiagramStatus = 'rascunho' | 'ativo' | 'arquivado';

const STATUS_LABEL: Record<DiagramStatus, string> = {
  rascunho: 'Rascunho',
  ativo: 'Ativo',
  arquivado: 'Arquivado',
};

const STATUS_CLASS: Record<DiagramStatus, string> = {
  rascunho: 'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-300',
  ativo: 'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-900 dark:bg-emerald-950/30 dark:text-emerald-300',
  arquivado: 'border-slate-200 bg-slate-100 text-slate-700 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300',
};

interface StatusBadgeProps {
  status: DiagramStatus;
  className?: string;
}

/** Badge de status (rascunho/ativo/arquivado) padronizado entre organograma e fluxograma. */
export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <Badge variant="outline" className={cn(STATUS_CLASS[status], className)}>
      {STATUS_LABEL[status]}
    </Badge>
  );
}
